import React from 'react'
import styles from './ResultFail.module.css'
import PropTypes from "prop-types";
import container from "postcss/lib/container";
import {Link} from "react-router-dom";
import {Icon} from 'semantic-ui-react'



function ResultFail(props) {

    ResultFail.prototype = {
        invoice : PropTypes.object.isRequired,
        paymentResult : PropTypes.object
    }


    return (
    <div className={styles.container}>

    <div className={styles.container}>
        <Icon inverted color='red' name='close' size='massive'  />
    </div>

        <div className={styles.container}>
            <label className={styles.label1}>Ödemeniz Tamamlanamadı! </label>
        <br/>
            <label className={styles.labelSoft}>{props.paymentResult.operationResult.resultCode} - {props.paymentResult.operationResult.resultDesc}</label>
        </div>


    <br />
    <br />
        <div>
            <Link to="/"> Farklı bir fatura için tekrar dene</Link>
        </div>

      </div>
  )
}

export default ResultFail
